export default __webpack_public_path__ + "static/media/radio-icon.1db973d6.svg";